import { createContext, useContext, useEffect, useState } from "react"
import { showNotify } from "../../Utils/Utils"

import { LogsInitContext } from "../LogsInitComponentesContext/LogsInitComponentesContext"
import { RequestOneContext } from "../RequestOneContext/RequestOneContext"
import { WebSocketContext } from "../WebSocket/WebSocketContext"
import { LogadoContext } from "../LogadoContext/LogadoContext"
import OneModal from "../../Components/OneModal/OneModal"
import { Box, Button } from "@mui/material"

export const UserContext = createContext()

let msgLogout = ''
export const UserProvider = ({ children }) => {
    const { LogInit } = useContext(LogsInitContext)
    LogInit('UserContext', 'contexto')

    const { requestOne } = useContext(RequestOneContext)
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { alterLogado } = useContext(LogadoContext)

    const [user, setUser] = useState({})
    const [check, setCheck] = useState({
        ramal: false,
        estado_jornada: false,
        motivoPausa: false,
        dt_checkin: false,
        humor: false
    })
    const [openModalLogout, setOpenModalLogout] = useState(false)

    const setDadosCheckin = (msg) => {
        setCheck({ ...check, dt_checkin: msg.data.dados_checkin?.dt || null, humor: msg.data.dados_checkin?.humor || "", ramal: msg.data.dados_checkin?.ramal || "", estado_jornada: msg.data.dados_checkin?.estado_jornada || null, motivoPausa: msg.data.dados_checkin?.id_obs || null })
    }

    useEffect(() => {
        let UserStorage = sessionStorage.getItem('o_mo_user')
        if (UserStorage) {
            UserStorage = JSON.parse(UserStorage)
            setUser(UserStorage)
        }
        addRoute('GetDadosCheckin', setDadosCheckin)
        addRoute('logout', logoutMsg)
    }, [])

    useEffect(() => {
        if (user && user.id != null) {
            sendWs('GetDadosCheckin', { id: user.id })
            addRoute('checkin_out', checkin)
            addRoute('pausa_retorno', pausa_retorno)
        }
    }, [user])

    const pausa_retorno = (msg) => {
        if (msg.data.id_usuario == user.id) {
            if (msg.data.cod == 201) {
                sendWs('GetDadosCheckin', { id: user.id })
                setCheck({
                    ...check,
                    dt_checkin: msg.data.dt,
                    ramal: msg.data.ramal,
                    estado_jornada: msg.data.pause ? 2 : 3,
                    motivoPausa: msg.data.id_obs
                })
                showNotify('success', msg.data.pause & msg.data.id_adm ? 'Um ADM iniciou sua pausa!' : msg.data.pause ? 'Pausa iniciada!' : !msg.data.pause & msg.data.id_adm ? 'Um ADM efetuou seu retorno!' : 'Retorno efetuado!')
            } else if (msg.data.cod == 401) {
                showNotify('error', msg.data.msg)
            }
        } else if (msg.data.cod == 401) {
            showNotify('error', msg.data.msg)
        } else if (user & user.id == msg.data.id_adm) {
            showNotify('success', msg.data.pause ? 'Pausa do operador iniciada!' : 'Retorno do operador efetuado!')
        }
    }
    const checkin = (msg) => {
        if (msg.data.id_usuario == user.id) {
            if (msg.data.cod == 201) {
                sendWs('GetDadosCheckin', { id: user.id })
                setCheck({
                    ...check,
                    dt_checkin: msg.data.dt,
                    ramal: msg.data.ramal,
                    estado_jornada: msg.data.checkin ? 1 : 4
                })
                showNotify('success', msg.data.checkin ? 'Checkin iniciado!' : msg.data.id_adm ? 'Um ADM efetuou seu checkout!' : 'Checkout efetuado!')
            } else if (msg.data.cod == 401 || msg.data.cod == 500) {
                showNotify('error', msg.data.msg)
            }
        } else if (user & user.id == msg.data.id_adm) {
            showNotify('success', 'Checkout do operador efetuado!')
        }
    }

    const [sessionId, setSessionId] = useState('')

    function getOrCreateSessionId() {
        let sessionId = localStorage.getItem('o_mo_id_session')

        if (!sessionId) {
            sessionId = `session_${Date.now()}`
            localStorage.setItem('o_mo_id_session', sessionId)
        }

        return sessionId
    }

    const login = async (data) => {
        const config_login = {
            url: '/login',
            method: 'post',
            data,
            sessionId
        }

        const response = await requestOne(config_login)

        if (response && response.nome) {
            sessionStorage.setItem("o_mo_user", JSON.stringify(response))
            localStorage.removeItem('o_ronda_resp')
            setUser(response)
            alterLogado(true)

            const currentSessionId = getOrCreateSessionId()
            setSessionId(currentSessionId)

            return true
        } else if (response.response.status == 401) {
            showNotify('warning', response.response.data.message)
            return false
        } else {
            return false
        }
    }

    const logout = (msg) => {
        if (msg) {
            msgLogout = msg
            setOpenModalLogout(true)
        }
        alterLogado(false)
        sessionStorage.removeItem("o_mo_user")
        location.reload()
    }

    const btnModalLogout = () => {
        return (
            <Box component='div' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button onClick={handleClose} color="one_primary" variant="contained" type="button">OK</Button>
            </Box>
        )
    }

    const logoutMsg = (msg) => {
        if (msg && msg.data && msg.data.msg_logout) {
            logout(msg.data.msg_logout)
        }
    }

    const handleClose = () => {
        setOpenModalLogout(false)
        location.reload()
    }

    const value = { login, user, check, logout }
    return (
        <UserContext.Provider value={value}>
            <div>
                {openModalLogout &&
                    <OneModal
                        open={openModalLogout}
                        setOpen={setOpenModalLogout}
                        titleText="Logout"
                        FooterButtons={btnModalLogout}
                        onClose={() => {}}
                    >
                        <Box component='span' sx={{ fontWeight: 700 }}>{msgLogout}</Box>
                    </OneModal>
                }
                {children}
            </div>
        </UserContext.Provider>
    )
}
